import get from "lodash/get";
import capitalize from "lodash/capitalize";

export const getUserType = (user) => {
  if (user.is_admin) {
    return "Admin";
  }
  if (user.staff) {
    return "Staff";
  }
  return capitalize(get(user, "client.type", "N/A"));
};
